import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './UserProfile.css';
import DiagnosticPopup from './DiagnosticPopup';

const UserProfile = ({ user, onLogout, diagnosticData, onDiagnosticLineClick }) => {
  const [selectedDiagnosticLine, setSelectedDiagnosticLine] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const handleLogout = async () => {
    try {
      await signOut(auth);
      onLogout();
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  // Écouter les clics de diagnostic depuis le parent
  useEffect(() => {
    if (onDiagnosticLineClick) {
      // Fonction pour gérer les clics reçus du tore
      window.handleDiagnosticClick = (index, x, y) => {
        console.log('🔍 UserProfile handleDiagnosticClick:', {
          index,
          hasData: !!(diagnosticData && diagnosticData[index]),
          dataAtIndex: diagnosticData && diagnosticData[index],
          hasMetrics42: !!(diagnosticData && diagnosticData[index] && diagnosticData[index].metrics_42),
          hasEquationResults: !!(diagnosticData && diagnosticData[index] && diagnosticData[index].equation_results),
          equationResultsKeys: (diagnosticData && diagnosticData[index] && diagnosticData[index].equation_results) ? Object.keys(diagnosticData[index].equation_results).length : 0
        });
        if (diagnosticData && diagnosticData[index]) {
          // S'assurer que l'index est correct dans les données
          const dataWithIndex = {
            ...diagnosticData[index],
            index: index // Force l'index correct
          };
          console.log('🔍 Setting selectedDiagnosticLine:', dataWithIndex);
          console.log('🎵 metrics_42 in dataWithIndex?', !!dataWithIndex.metrics_42, dataWithIndex.metrics_42);
          setSelectedDiagnosticLine(dataWithIndex);
          setPopupPosition({ x, y });
        }
      };
    }
    
    return () => {
      delete window.handleDiagnosticClick;
    };
  }, [diagnosticData, onDiagnosticLineClick]);

  const closePopup = () => {
    setSelectedDiagnosticLine(null);
  };

  return (
    <div className="profile-overlay">
      {/* Popup de diagnostic */}
      {selectedDiagnosticLine && (
        <DiagnosticPopup
          data={selectedDiagnosticLine}
          position={popupPosition}
          onClose={closePopup}
        />
      )}

    </div>
  );
};

export default UserProfile;